import { useState, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
};

const useMediaQuery = () => {
  const [mediaQueries, setMediaQueries] = useState({
    isSm: window.innerWidth < breakpoints.sm,
    isMd: window.innerWidth > breakpoints.md && window.innerWidth < breakpoints.lg,
    isLg: window.innerWidth > breakpoints.lg && window.innerWidth < breakpoints.xl,
    isXl: window.innerWidth < breakpoints.xl,
    is2xl: window.innerWidth > breakpoints.xl,
    isMobile: window.innerWidth < breakpoints.lg,
    isLowerThenLg: window.innerWidth < breakpoints.lg,
  });

  const debouncedHandleResize = useDebouncedCallback(() => {
    const newValues = {
      isSm: window.innerWidth < breakpoints.sm,
      isMd: window.innerWidth > breakpoints.md && window.innerWidth < breakpoints.lg,
      isLg: window.innerWidth > breakpoints.lg && window.innerWidth < breakpoints.xl,
      isXl: window.innerWidth < breakpoints.xl,
      is2xl: window.innerWidth > breakpoints.xl,
      isMobile: window.innerWidth < breakpoints.lg,
      isLowerThenLg: window.innerWidth < breakpoints.lg,
    };
    setMediaQueries((prevValues) => {
      if (JSON.stringify(prevValues) === JSON.stringify(newValues)) {
        return prevValues;
      }
      return newValues;
    });
  }, 100);

  useEffect(() => {
    window.addEventListener('resize', debouncedHandleResize);

    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, []);

  return mediaQueries;
};

export default useMediaQuery;
